// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SignOutComponent} from './SignOut.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSignOut = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SignOutComponent/>
  </Icon>
));
